import { EntityBase } from 'projects/sepidz-web-framework/src/lib/models/entity-base.model';

export class SettlementReferenceModel extends EntityBase {
    SettlementId :number;
    SettlementRefrenceId :number;
}